import {
    BarChartOutlined,
    CheckCircleOutlined,
    DollarOutlined,
    ShoppingOutlined
} from "@ant-design/icons";
import { Col, Row } from "antd";
import { useEffect, useState } from "react";
import { formatCurrency } from "../../../../utils";
import {
    itemsTrendOptions,
    orderTrendOptions,
    warehouseUsageOptions
} from "./Options";
import KPIWidget from "./Widget";

const KPICards = ({ data, loading }) => {
    const [hoveredValues, setHoveredValues] = useState({
        dailyItemsFulfilled: 0,
        dailyOrdersFulfilled: 0,
    });


    useEffect(() => {
        setHoveredValues({
            dailyItemsFulfilled: data?.dailyItemsFulfilled,
            dailyOrdersFulfilled: data?.dailyOrdersFulfilled,
        });
    }, [data]);

    const generateChartOptionsWithHover = (
        key,
        baseOptions,
        seriesData,
        defaultValue
    ) => ({
        ...baseOptions,
        chart: {
            ...baseOptions.chart,
            events: {
                mouseMove: (event, chartContext, config) => {
                    const index = config.dataPointIndex;
                    const currentValue = seriesData[index];

                    if (index !== -1 && currentValue !== undefined) {
                        setHoveredValues(prev => {
                            if (prev[key] !== currentValue) {
                                return { ...prev, [key]: currentValue };
                            }
                            return prev;
                        });
                    }
                },
                mouseLeave: () => {
                    setHoveredValues(prev => {
                        if (prev[key] !== defaultValue) {
                            return { ...prev, [key]: defaultValue };
                        }
                        return prev;
                    });
                },
            },
        },
    });

    return (
        <Row gutter={[24, 24]} style={{ marginBottom: 32 }}>
            <Col xs={24} sm={24} md={12} lg={12} xl={6}>
                <KPIWidget
                    title="Total Stock Value"
                    isChart={false}
                    value={formatCurrency(data?.totalStockValue)}
                    color="#1e88e5"
                    icon={<DollarOutlined />}
                    loading={loading.totalStock}
                />
            </Col>

            <Col xs={24} sm={24} md={12} lg={12} xl={6}>
                <KPIWidget
                    title="Orders Fulfilled"
                    value={hoveredValues.dailyOrdersFulfilled}
                    color="#43a047"
                    icon={<CheckCircleOutlined />}
                    chartOptions={generateChartOptionsWithHover(
                        "dailyOrdersFulfilled",
                        {
                            ...orderTrendOptions,
                            tooltip: {
                                custom: ({ dataPointIndex }) => {
                                    const categories = data?.trendCategory;
                                    const label = categories[dataPointIndex] || '';
                                    return `<div class="apex-tooltip-custom">${label}</div>`;
                                },
                                marker: { show: false }
                            },
                            xaxis: {
                                categories: data?.trendCategory
                            }
                        },
                        data?.orderTrend,
                        data?.dailyOrdersFulfilled
                    )}
                    chartSeries={[{ data: data?.orderTrend }]}
                    loading={loading.fulfilled}
                />
            </Col>

            <Col xs={24} sm={24} md={12} lg={12} xl={6}>
                <KPIWidget
                    title="Items Fulfilled"
                    value={hoveredValues.dailyItemsFulfilled}
                    color="#ff7043"
                    icon={<ShoppingOutlined />}
                    chartOptions={generateChartOptionsWithHover(
                        "dailyItemsFulfilled",
                        {
                            ...itemsTrendOptions,
                            tooltip: {
                                custom: ({ dataPointIndex }) => {
                                    const categories = data?.trendCategory;
                                    const label = categories[dataPointIndex] || '';
                                    return `<div class="apex-tooltip-custom">${label}</div>`;
                                },
                                marker: { show: false }
                            },
                            xaxis: {
                                categories: data?.trendCategory
                            }
                        },
                        data?.itemsTrend,
                        data?.dailyItemsFulfilled
                    )}
                    chartSeries={[{ data: data?.itemsTrend }]}
                    loading={loading.fulfilled}
                />
            </Col>

            <Col xs={24} sm={24} md={12} lg={12} xl={6}>
                <KPIWidget
                    title="Warehouse Capacity"
                    value=""
                    color="#ffa726"
                    icon={<BarChartOutlined />}
                    chartOptions={warehouseUsageOptions}
                    chartSeries={data?.warehouseUsageSeries}
                    chartType="bar"
                    height={100}
                    loading={loading.capacity}
                />
            </Col>
        </Row>
    );
};

export default KPICards;
